var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTailwind = function SvgTailwind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    viewBox: "0 0 52 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#06B6D4",
    fillRule: "evenodd",
    d: "M25.517 0C18.712 0 14.46 3.382 12.758 10.146C15.31 6.764 18.287 5.496 21.689 6.341C23.63 6.823 25.018 8.223 26.553 9.773C29.055 12.297 31.951 15.218 38.275 15.218C45.079 15.218 49.332 11.836 51.033 5.073C48.482 8.455 45.505 9.723 42.103 8.877C40.161 8.395 38.773 6.995 37.238 5.446C34.736 2.92 31.841 0 25.517 0ZM12.758 15.218C5.954 15.218 1.701 18.6 0 25.364C2.552 21.982 5.529 20.714 8.93 21.559C10.872 22.041 12.26 23.441 13.795 24.991C16.297 27.515 19.192 30.436 25.517 30.436C32.321 30.436 36.574 27.055 38.275 20.291C35.723 23.673 32.746 24.941 29.344 24.096C27.403 23.613 26.015 22.213 24.48 20.664C21.978 18.14 19.082 15.218 12.758 15.218V15.218Z",
    clipRule: "evenodd"
  })));
};

export default SvgTailwind;